import React from 'react';

// Components
import { DatePicker } from '@/views/components/inputs';
import { Label } from '../Label/Label';

// Libraries
import moment from 'moment';
import { useSelector } from 'react-redux';

// Types
import { ReduxState } from '@/redux/modules/types';

// Utils
import { formatMessage, formatMessageWithLocale, LOCALE } from '@/utils/i18n';

const MAX_PAST_YEARS = 20;

interface DatesProps {
  fromDate?: Date;
  i18nBasePath: string;
  loading: boolean;
  onSetFromDate: (date: Date) => void;
  onSetToDate: (date: Date) => void;
  toDate?: Date;
}

export const Dates: React.FC<DatesProps> = ({ fromDate, i18nBasePath, loading, onSetFromDate, onSetToDate, toDate }) => {
  const locale = useSelector((state: ReduxState) => state.intl.locale || LOCALE.EN_CA);
  const customFormat = formatMessageWithLocale(`${i18nBasePath}.DateFormat`, locale);
  const minDate = moment().subtract(MAX_PAST_YEARS, 'years').toDate();
  const commonDatePickerProps = {
    allowPrevNext2: true,
    calendarType: 'US' as const,
    className: 'date-picker-v2',
    customFormat,
    disabled: loading,
    icon: 'icon-calendar-new',
    locale,
  };

  return (
    <div className="field-container">
      <Label htmlFor="specific-date" label={formatMessageWithLocale(`${i18nBasePath}.SpecificDate`, locale)} />
      <div className="specific-date-container">
        <DatePicker
          {...commonDatePickerProps}
          customPlaceholder={formatMessage(`${i18nBasePath}.StartDatePlaceholder`)}
          defaultDate={fromDate ?? undefined}
          maxDate={toDate}
          minDate={minDate}
          onDateChange={onSetFromDate}
        />
        <span className="to-label">To</span>
        <DatePicker
          {...commonDatePickerProps}
          customPlaceholder={formatMessage(`${i18nBasePath}.StartDatePlaceholder`)}
          defaultDate={toDate ?? undefined}
          minDate={fromDate ?? minDate}
          onDateChange={onSetToDate}
        />
      </div>
    </div>
  );
};
